import { Box } from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { WsTypography } from 'wisestep-base';

import { StandardHeightsByRows } from '../../..';
import usePostgreFollowUpWidgetData from '../../../../../features/composableAnalytics/DerivedCharts/followUps/hooks/usePostgreFollowUpWidgetData';
import { FollowUpWidget } from '../../../../../features/composableAnalytics/DerivedCharts/helper';
import { CustomNoRowsOverlay } from '../../../helper/showCustomizeNoDataTextDataGrid';
import { IPostgresFollowUpDTO } from '../types/postgresFollowUpDTO';
import { IFollowUpWidgetProp } from '../types/postgresFollowUpWidgetProp';
import {
  defaultFollowUpWidgetData,
  getColumnsForFollowUps,
  getTableDataForFollowUps,
} from '../utils/followUpHelper';

const FollowUpTablePostgres = ({ query, title, widgetName }: IFollowUpWidgetProp) => {
  const { widgetData } = usePostgreFollowUpWidgetData<IPostgresFollowUpDTO>(
    query,
    defaultFollowUpWidgetData
  );

  const rowNum = [FollowUpWidget.TASK_STATUS].includes(widgetName) ? 5 : 3;

  const tableData = getTableDataForFollowUps(widgetName, widgetData) ?? [];
  const columns = getColumnsForFollowUps(widgetName, widgetData);
  return (
    <Box>
      <WsTypography bold={true}>{title}</WsTypography>
      <Box mt={1.5} sx={{ height: StandardHeightsByRows[rowNum] }}>
        <DataGrid
          columns={columns}
          rows={tableData}
          components={{ Toolbar: GridToolbar, NoRowsOverlay: CustomNoRowsOverlay }}
          pageSize={5}
          rowsPerPageOptions={[5]}
          sx={{ overflowY: 'hidden' }}
          initialState={{
            sorting: {
              sortModel: [{ field: 'count', sort: 'desc' }],
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default FollowUpTablePostgres;
